import React, { useState } from 'react';
import { TYPES } from '../data/types';
import Coin from '../components/Coin';
import './EmailCapture.css';

export default function EmailCapture({ result, tracking, cookieConsent, onSubmit }) {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const mbti   = result ? result.split('-')[0] : 'INFP';
  const atCode = result ? (result.split('-')[1] || 'A') : 'A';
  const td     = TYPES[mbti] || TYPES['INFP'];
  const coin   = td.coin;

  const handleSubmit = async () => {
    if (!email.includes('@') || !email.includes('.')) { setError('Please enter a valid email address.'); return; }
    setLoading(true); setError('');
    try {
      await fetch('/api/save_result.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email, type: mbti, at_type: atCode,
          cid: tracking?.cid || '', uid: tracking?.uid || '',
          consent_cookies: cookieConsent === true,
          consent_email: true,
          consent_ts: new Date().toISOString(),
          tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
          lang: navigator.language,
        }),
      });
      onSubmit(email);
    } catch {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="ec">
      <div className="ec-card">
        {/* Coin preview */}
        <div className="ec-preview">
          <div className="ec-coin-wrap">
            <Coin type={mbti} coin={coin} size={120} />
          </div>
          <div className="ec-type">{mbti}-{atCode}</div>
          <div className="ec-name">{td.name}</div>
          <div className="ec-tagline">{td.tagline}</div>
          <div className="ec-metal-badge">
            {coin.metal} · {coin.rarity}
          </div>
        </div>

        {/* Form */}
        <div className="ec-form">
          <div className="ec-icon">💌</div>
          <h2 className="ec-title">Receive Your Full Coin Report</h2>
          <p className="ec-sub">Enter your email to get a complete deep-dive analysis of your personality coin — free.</p>
          <input
            type="email"
            className="ec-input"
            placeholder="your@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          />
          {error && <p className="ec-error">{error}</p>}
          <button className="ec-btn" onClick={handleSubmit} disabled={loading}>
            {loading ? '...' : 'Get My Report →'}
          </button>
          <button className="ec-skip" onClick={() => onSubmit('')}>
            View result without email
          </button>
          <p className="ec-privacy">🔒 No spam. Unsubscribe anytime. Your data is secure.</p>
        </div>
      </div>
    </div>
  );
}
